import React from 'react'
import LoadingStyled from './styled'

const Loading = () => <LoadingStyled>Loading...</LoadingStyled>

export default Loading
